/**
 * The seam between the fetch layer and the session-expiry handling.
 *
 * `apiFetch` reports every 401 here, and the app entry registers what to do
 * about it (see `session-expiry.ts`). It lives in its own import-free module so
 * `api.ts` can report without importing `session.ts`, which imports `api.ts`.
 */

type Listener = () => void;

let listener: Listener | null = null;

/** Registers the one listener; returns a function that removes it. */
export function onUnauthorized(next: Listener): () => void {
  listener = next;
  return () => {
    if (listener === next) listener = null;
  };
}

/**
 * Reports a 401 from the backend. Better Auth's own endpoints are ignored: a
 * rejected password or 2FA code is a 401 that says nothing about the session.
 */
export function reportUnauthorized(url: string): void {
  if (url.includes("/api/auth/")) return;
  listener?.();
}
